import { render } from "./UploadView.vue?vue&type=template&id=1d2c4879"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"

import exportComponent from "/home/teo/git_repos/cancer-classifier-app/cancer-classifier-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__